import { render, staticRenderFns } from "./game-detail-recorde.vue?vue&type=template&id=5c9c3bc0&scoped=true&lang=pug"
import script from "./game-detail-recorde.vue?vue&type=script&lang=js"
export * from "./game-detail-recorde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9c3bc0",
  null
  
)

export default component.exports